import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    interesBancarioRubroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, interesBancarioRubroId) {
        state.id = interesBancarioRubroId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_INTERES_BANCARIO_RUBRO'(state, interesBancarioRubro) {
        state.nombre = interesBancarioRubro.nombre.toUpperCase().trim();
        state.inactivo = interesBancarioRubro.inactivo;
        state.rowVersion = interesBancarioRubro.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.interesBancarioRubroDatos = [];
    },
    'SET_DATOS'(state, interesBancarioRubroDatos) {
        state.interesBancarioRubroDatos = interesBancarioRubroDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, interesBancarioRubroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', interesBancarioRubroId);
            
            if (interesBancarioRubroId != 0){
                apiAxios.get('intereses-bancarios-rubros/' + interesBancarioRubroId + '/abm' ) 
                    .then(res => {
                        commit('SET_INTERES_BANCARIO_RUBRO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let interesBancarioRubro= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
                rowVersion: state.rowVersion,
            }
            
            let url = 'intereses-bancarios-rubros';
            if (state.id != 0) {
                url += '/' + state.id;
            }

            apiAxios.post(url, interesBancarioRubro)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, interesBancarioRubroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (interesBancarioRubroId != 0) {
                apiAxios.get('intereses-bancarios-rubros/' + interesBancarioRubroId) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}